import { render, staticRenderFns } from "./download-view.vue?vue&type=template&id=1f357487&scoped=true&"
import script from "./download-view.vue?vue&type=script&lang=js&"
export * from "./download-view.vue?vue&type=script&lang=js&"
import style0 from "./download-view.vue?vue&type=style&index=0&id=1f357487&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f357487",
  null
  
)

export default component.exports